/* eslint-disable react/require-default-props */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Container, Error, Select, Label } from './style';

export interface IOption {
  id: number | string;
  value: string;
}

interface IProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  placeholder?: string;
  options: Array<IOption>;
  setValue: (value: string) => void;
  sizeDisplay?: 'lg' | 'md' | 'sm';
  error?: boolean;
  isShowOptId?: boolean;
  errorMessage?: string;
  labelTxt?: string;
  haveMargin?: boolean;
}

const StyledSelect = ({
  options,
  placeholder,
  setValue,
  sizeDisplay = 'lg',
  value,
  isShowOptId = false,
  error = false,
  errorMessage = '',
  haveMargin = false,
  labelTxt,
  ...rest
}: IProps) => (
  <>
  {labelTxt && <Label>{labelTxt}</Label>}
  <Container haveMargin={haveMargin} sizeDisplay={sizeDisplay} error={error}>
    <Select
      onChange={(event) => setValue(event.target.value)}
      value={value}
      {...rest}
    >
      {placeholder && <option value="">{placeholder}</option>}
      {options?.map((option) => (
        <option key={option.id} value={option.value}>
          {!isShowOptId ? option.value :option.id}
        </option>
      ))}
    </Select>
    {error && errorMessage !== '' && <Error>{errorMessage}</Error>}
  </Container>
  </>
);

export { StyledSelect };
